import * as React from 'react';
import { mergeClasses } from '../constants';

type Props = {
  color?: string;
  children: React.ReactNode;
  className?: string;
  title?: string;
};

export default class Panel extends React.Component<Props> {
  render() {
    const { color, className, title, children, ...rest } = this.props;
    return (
      <div
        className={mergeClasses(['panel', color || 'white-box', className])}
        {...rest}
      >
        {title && <h4>{title}:</h4>}
        {children}
      </div>
    );
  }
}
